import { createContext, useContext } from 'react';
import { IdentityProvider } from '../Api/Auth/identityProvider';

export interface AuthSessionState {
  isAuthenticated: boolean;
  isPending: boolean;
  // A failure another sign-in redirect will not fix; the route guard must show it rather than redirect into it.
  error?: boolean;
}

export interface AuthContextType {
  provider: IdentityProvider;
  authState: AuthSessionState | null;
  token: string | null;
  signIn: (returnTo: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an auth provider');
  }
  return context;
};
